import { render } from "./DataUploadPage.vue?vue&type=template&id=48477308"
import script from "./DataUploadPage.vue?vue&type=script&lang=js"
export * from "./DataUploadPage.vue?vue&type=script&lang=js"

import "./DataUploadPage.vue?vue&type=style&index=0&id=48477308&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__